// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-container.adg3-editor #rte-toolbar #synchrony-presence-overlay,
#content.edit.adg3-editor #rte-toolbar #synchrony-presence-overlay {
	z-index: 0;
	right: 9px;
	position: relative;
	top: -3px;
	display: inline-block;
}

.editor-container.adg3-editor #rte-toolbar #synchrony-presence-overlay a.aui-button,
#content.edit.adg3-editor #rte-toolbar #synchrony-presence-overlay a.aui-button {
	border-radius: 20px;
	background: var(--ds-background-selected, #ecedf0);
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar.active:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar.active:before {
	border-radius: 10px;
	border: 1px solid var(--ds-border-inverse, #ffffff);
	font-weight: bold;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar > img,
#content.edit.adg3-editor .collaborative-avatars-list .avatar > img {
	display: inline-block;
	height: 100%;
	border-radius: 30px;
	border: 3px solid var(--ds-border-inverse, #fff);
}

.editor-container.adg3-editor #avatar-list,
#content.edit.adg3-editor #avatar-list {
	list-style: none;
	margin: 0;
	position: relative;
	right: -1px;
	top: -6px;
	bottom: 0;
	display: flex;
	flex-wrap: nowrap;
	font-size: 0;
	z-index: 1;
	direction: rtl;
	padding: 0 5px 0 10px;
}

.editor-container.adg3-editor #avatar-list li.avatar-item,
#content.edit.adg3-editor #avatar-list li.avatar-item {
	margin-left: -2px;
}

.editor-container.adg3-editor
	#avatar-list.has-overlay
	.avatar-item:nth-child(-n + 5)
	.avatar:before,
#content.edit.adg3-editor #avatar-list.has-overlay .avatar-item:nth-child(-n + 5) .avatar:before {
	opacity: 1;
	transform: translate(2px, 3px);
	-webkit-transform: translate(2px, 3px);
}

.editor-container.adg3-editor #avatar-list.has-overlay .avatar-item:nth-child(n + 6) .avatar:before,
#content.edit.adg3-editor #avatar-list.has-overlay .avatar-item:nth-child(n + 6) .avatar:before {
	opacity: 0;
	/* stylelint-disable design-system/ensure-design-token-usage */
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p0 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p0 .avatar:before {
	background-color: #172b4d;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p1 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p1 .avatar:before {
	background-color: #0049b0;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p2 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p2 .avatar:before {
	background-color: #00875a;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p3 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p3 .avatar:before {
	background-color: #ff8b00;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p4 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p4 .avatar:before {
	background-color: #de350b;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p5 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p5 .avatar:before {
	background-color: #5243aa;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p6 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p6 .avatar:before {
	background-color: #a5adba;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p7 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p7 .avatar:before {
	background-color: #2684ff;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p8 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p8 .avatar:before {
	background-color: #57d9a3;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p9 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p9 .avatar:before {
	background-color: #5e6c84;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p10 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p10 .avatar:before {
	background-color: #ff8f73;
}

.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p11 .avatar:before,
#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p11 .avatar:before {
	background-color: #998dd9;
	/* stylelint-enable design-system/ensure-design-token-usage */
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/synchrony-presence.css"],"names":[],"mappings":"AAAA;;CAEC,UAAU;CACV,UAAU;CACV,kBAAkB;CAClB,SAAS;CACT,qBAAqB;AACtB;;AAEA;;CAEC,mBAAmB;CACnB,kDAAkD;AACnD;;AAEA;;CAEC,mBAAmB;CACnB,mDAAmD;CACnD,iBAAiB;AAClB;;AAEA;;CAEC,qBAAqB;CACrB,YAAY;CACZ,mBAAmB;CACnB,gDAAgD;AACjD;;AAEA;;CAEC,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,SAAS;CACT,aAAa;CACb,iBAAiB;CACjB,YAAY;CACZ,UAAU;CACV,cAAc;CACd,qBAAqB;AACtB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;;;;CAKC,UAAU;CACV,8BAA8B;CAC9B,sCAAsC;AACvC;;AAEA;;CAEC,UAAU;CACV,8DAA8D;AAC/D;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,6DAA6D;AAC9D","sourcesContent":[".editor-container.adg3-editor #rte-toolbar #synchrony-presence-overlay,\n#content.edit.adg3-editor #rte-toolbar #synchrony-presence-overlay {\n\tz-index: 0;\n\tright: 9px;\n\tposition: relative;\n\ttop: -3px;\n\tdisplay: inline-block;\n}\n\n.editor-container.adg3-editor #rte-toolbar #synchrony-presence-overlay a.aui-button,\n#content.edit.adg3-editor #rte-toolbar #synchrony-presence-overlay a.aui-button {\n\tborder-radius: 20px;\n\tbackground: var(--ds-background-selected, #ecedf0);\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar.active:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar.active:before {\n\tborder-radius: 10px;\n\tborder: 1px solid var(--ds-border-inverse, #ffffff);\n\tfont-weight: bold;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar > img,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar > img {\n\tdisplay: inline-block;\n\theight: 100%;\n\tborder-radius: 30px;\n\tborder: 3px solid var(--ds-border-inverse, #fff);\n}\n\n.editor-container.adg3-editor #avatar-list,\n#content.edit.adg3-editor #avatar-list {\n\tlist-style: none;\n\tmargin: 0;\n\tposition: relative;\n\tright: -1px;\n\ttop: -6px;\n\tbottom: 0;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tfont-size: 0;\n\tz-index: 1;\n\tdirection: rtl;\n\tpadding: 0 5px 0 10px;\n}\n\n.editor-container.adg3-editor #avatar-list li.avatar-item,\n#content.edit.adg3-editor #avatar-list li.avatar-item {\n\tmargin-left: -2px;\n}\n\n.editor-container.adg3-editor\n\t#avatar-list.has-overlay\n\t.avatar-item:nth-child(-n + 5)\n\t.avatar:before,\n#content.edit.adg3-editor #avatar-list.has-overlay .avatar-item:nth-child(-n + 5) .avatar:before {\n\topacity: 1;\n\ttransform: translate(2px, 3px);\n\t-webkit-transform: translate(2px, 3px);\n}\n\n.editor-container.adg3-editor #avatar-list.has-overlay .avatar-item:nth-child(n + 6) .avatar:before,\n#content.edit.adg3-editor #avatar-list.has-overlay .avatar-item:nth-child(n + 6) .avatar:before {\n\topacity: 0;\n\t/* stylelint-disable design-system/ensure-design-token-usage */\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p0 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p0 .avatar:before {\n\tbackground-color: #172b4d;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p1 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p1 .avatar:before {\n\tbackground-color: #0049b0;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p2 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p2 .avatar:before {\n\tbackground-color: #00875a;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p3 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p3 .avatar:before {\n\tbackground-color: #ff8b00;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p4 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p4 .avatar:before {\n\tbackground-color: #de350b;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p5 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p5 .avatar:before {\n\tbackground-color: #5243aa;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p6 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p6 .avatar:before {\n\tbackground-color: #a5adba;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p7 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p7 .avatar:before {\n\tbackground-color: #2684ff;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p8 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p8 .avatar:before {\n\tbackground-color: #57d9a3;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p9 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p9 .avatar:before {\n\tbackground-color: #5e6c84;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p10 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p10 .avatar:before {\n\tbackground-color: #ff8f73;\n}\n\n.editor-container.adg3-editor .collaborative-avatars-list .avatar-item.p11 .avatar:before,\n#content.edit.adg3-editor .collaborative-avatars-list .avatar-item.p11 .avatar:before {\n\tbackground-color: #998dd9;\n\t/* stylelint-enable design-system/ensure-design-token-usage */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
